module.exports = __webpack_public_path__ + "static/Utah-Basketball-edde832ac2638ad53f3c38902a912b87.jpg";